import moment from 'moment';
import { Box, Flex } from 'reflexbox';
import styled from 'styled-components';

import { tokens } from '@treams/treams-ui';

const LearningCalendarWeekdayHeaderElement = styled(Flex)`
	border-top: 1px solid ${tokens.border.subtle};
`;

const LearningCalendarWeekdayHeaderCellElement = styled(Box)`
	color: ${tokens.text.secondary};
	font-size: ${tokens.typography.sizes.small}px;
	text-align: center;
	border-right: 1px solid ${tokens.border.subtle};

	:last-child {
		border-right-width: 0;
	}
`;

const LearningCalendarWeekdayHeader = () => {
	const now = moment().startOf('week').isoWeekday(0);

	return (
		<LearningCalendarWeekdayHeaderElement>
			{Array(7)
				.fill(null)
				.map((_, index) => (
					<LearningCalendarWeekdayHeaderCellElement
						key={`LearningCalendarWeekdayHeaderCell-${index + 1}`}
						p={2}
						flexBasis={1}
						flexGrow={1}
					>
						{now
							.clone()
							.add(index + 1, 'days')
							.format('dddd')}
					</LearningCalendarWeekdayHeaderCellElement>
				))}
		</LearningCalendarWeekdayHeaderElement>
	);
};

export default LearningCalendarWeekdayHeader;
